const Loader = () => null;

export default Loader;